export var noopLogger = new Proxy({}, {
    get: function () { return function () { return null; }; }
});
//# sourceMappingURL=noopLogger.js.map